import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { useRoute } from 'vue-router'
import App from './App.vue';

import jQuery from "jquery";
const $ = jQuery;
window.$ = $;

import router from './router';

import './registerServiceWorker';
import VueMobileDetection from "vue-mobile-detection";


import { createDeviceDetector } from "next-vue-device-detector";
export const device = createDeviceDetector()


const pinia = createPinia();

pinia.use(({ store }) => {
  store.route = useRoute();
})




createApp(App).use(router).use($).use(pinia).use(VueMobileDetection).use(device).mount('#app');
